import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiFormGroup from "@mui/material/FormGroup";
import classNames from "classnames";
export const FormGroup = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    row = false,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiFormGroup, _extends({
    className: classNames("prmbl-formGroup", className),
    ref: ref,
    row: row
  }, otherProps));
});
FormGroup.displayName = "FormGroup";
export default FormGroup;